// extracted by mini-css-extract-plugin
module.exports = {"row":"reservedCapacityRow_row__QSOWR"};